// extracted by mini-css-extract-plugin
export default {"mdl":"styles_mdl__1-0Ab","mdlContent":"styles_mdlContent__bDemx t-8 t-m-0 b-16 b-m-0"};